import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=08d1bebd&scoped=true"
import script from "./CatalogueList.vue?vue&type=script&lang=js"
export * from "./CatalogueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1bebd",
  null
  
)

export default component.exports